import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import * as GAMEOBJECTS from '@/gameobjects/index.js';

import {statenodeplayer} from '@/states/nodeplayer.js';

import cartridge from 'public/cartridge.json';

/**
 * Creates Games.
 * @example
 * const game = new Game();
 */
class Game {

    /**
     * Stores the Hypercube.js Game Engine currently being used.
     * @type {import('@hypercubejs/hypercubejs').Engine}
     * @private
     */
    $engine;

    /**
     * Stores the ResizeObserver object.
     * @type {ResizeObserver}
     * @private
     */
    $resizeobserver;

    /**
     * Creates a new Game.
     */
    constructor() {

        this.$engine = new HYPERCUBEJS.Engine();

        this.$engine.setdeviceviewer(new HYPERCUBEJS.DeviceViewer());
        this.$engine.deviceviewer.appendto(document.body);
        this.$engine.deviceviewer.focus();

        this.$resizeobserver = new ResizeObserver(() => {

            this.$engine.resize();
        });

        this.$resizeobserver.observe(document.body);

        window.addEventListener('beforeunload', () => {

            this.destroy();
        });
    }

    /**
     * Destroys the Game.
     * @public
     */
    destroy() {

        this.$resizeobserver.disconnect();

        this.$engine.destroy();
    }

    /**
     * Starts the Game.
     * @public
     */
    start() {

        const noderoot = new HYPERCUBEJS.Node('node root');

        const mapping = {

            'brick1x1x1': GAMEOBJECTS.gameobjectbrick1x1x1,
            'brick1x1x1traversable': GAMEOBJECTS.gameobjectbrick1x1x1traversable,
            // 'brick1x1x1traversable': GAMEOBJECTS.gameobjectbrick1x1x1,
            'brick2x2x2': GAMEOBJECTS.gameobjectbrick2x2x2,
            'plane4x4': GAMEOBJECTS.gameobjectplane4x4,
            'plane16x16': GAMEOBJECTS.gameobjectplane16x16,
            'plane32x32': GAMEOBJECTS.gameobjectplane32x32,
            'plane1080x1080': GAMEOBJECTS.gameobjectplane1080x1080,

            'soundambiant': GAMEOBJECTS.gameobjectsoundambiant,
            'coremountain': GAMEOBJECTS.gameobjectcoremountain,
            'coretemple': GAMEOBJECTS.gameobjectcoretemple,
            'coretree': GAMEOBJECTS.gameobjectcoretree,
            'coreend': GAMEOBJECTS.gameobjectcoreend,
        };

        cartridge.gameobjects.forEach(($gameobject) => {

            const {model, translation, type, uuid} = $gameobject;

            const factorygameobject = mapping[type];

            if (typeof factorygameobject === 'undefined') {

                return;
            }

            const gameobject = factorygameobject(model);
            // const gameobject = factorygameobject(new HYPERCUBEJS.MaterialColor('material random', {'color': [Math.random() * 0.8 + 0.2, Math.random() * 0.8 + 0.2, Math.random() * 0.8 + 0.2]}));

            gameobject.setuuid(uuid);
            gameobject.translate([...translation]);

            noderoot.addchild(gameobject);
        });

        // -------------------

        const nodecamera = GAMEOBJECTS.gameobjectcamera();
        const nodeplayer = GAMEOBJECTS.gameobjectplayer();

        nodeplayer.addchild(nodecamera);
        noderoot.addchild(nodeplayer);

        // nodeplayer.translate([0, 0.25, 4]);
        nodeplayer.translate([0, 0.25, 24]);
        // nodeplayer.translate([0, 0.25, -16]);
        // nodeplayer.rotate(HYPERCUBEJS.QUATERNION.fromeuler([0, 90 * HYPERCUBEJS.CONSTANTS.RADIANS, 0]));



        const scene = new HYPERCUBEJS.Scene('demo');



        console.log(scene);



        scene.setnoderoot(noderoot);
        scene.setnodecamera(nodecamera);



        scene.setantialiasing(false);



        // const colorambiant = HYPERCUBEJS.DEFAULTS.colorambiant();
        const colorambiant = HYPERCUBEJS.VECTOR3.create([0.6, 0.6, 0.7]);
        // const colorambiant = HYPERCUBEJS.VECTOR3.create([0.4, 0.4, 0.5]);
        // const colorskybox = HYPERCUBEJS.VECTOR3.create([0, 0, 0]);
        // const colorskybox = HYPERCUBEJS.VECTOR3.create([0.4, 0.6, 0.8]);
        const colorskybox = HYPERCUBEJS.VECTOR3.create([1, 1, 1]);

        scene.setlightambiant(new HYPERCUBEJS.LightAmbiant('Light Ambiant', colorambiant));
        scene.setlightdirectional(new HYPERCUBEJS.LightDirectional('Light Directional', [-0.4, -0.8, -0.2], [1.0, 1.0, 0.8]));
        // scene.setlightdirectional(new HYPERCUBEJS.LightDirectional('Light Directional', [-0.4, -0.8, -0.2], [1.0, 1.0, 0.8]));
        scene.setskybox(new HYPERCUBEJS.Skybox('Skybox', colorskybox));

        // scene.setfog(new HYPERCUBEJS.Fog(colorskybox, 0, 16, 1.0));
        // scene.setfog(new HYPERCUBEJS.Fog(colorskybox, 8, 64, 0.8));

        // -------------------

        // statenodeplayer.setstate(nodeplayer);

        // -------------------

        const systems = [

            new HYPERCUBEJS.SystemInput(), // PUIS new HYPERCUBEJS.SystemFSM()
            new HYPERCUBEJS.SystemScript(),
            new HYPERCUBEJS.SystemCollisionAABB(),
            new HYPERCUBEJS.SystemRender(32, 4096, -0.0007),
            new HYPERCUBEJS.SystemSpatialization()
        ];







        // @TODO : const helpers = [new HYPERCUBEJS.HELPERS.HelperRaycast()];
        // @TODO : this.$engine.use(scene, systems, helpers);

        // @TODO : avoir un system[] par défaut dans Engine
        this.$engine.use(scene, systems);
        // this.$engine.use(new HYPERCUBEJS.Scene('empty'), systems);
        this.$engine.start();
        this.$engine.run(60);
    }
}

export {

    Game
};

export default Game;
